import { Trash2 } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconTrash2(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Trash2 />
    </IconWrapper>
  );
}
